module.exports = __webpack_public_path__ + "img/video1-preview.fa5207b6.gif";